import { useEffect } from "react";
import useSearchState from "../search/useSearchState";
import { adsViews } from "../ui/common/adsViews";

export default function useAdsView() {
	const { loading, error, result, resultExists } = useSearchState();

	useEffect(() => {
		if (!loading && !error && resultExists) {
			const addViews = result?.get("addViews");

			if (addViews) {
				const { url, params } = addViews.toJS();
				adsViews(url, params);
			}
		}
	}, [loading, error, result]);
}
